import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";

interface CustomAccordionProps {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, expanded: boolean) => void;
  headerText: string;
  headerVariant?: "subtitle1" | "subtitle2" | "body1";
  children?: React.ReactNode;
  id: string;
}

const CustomAccordionSummary = styled(AccordionSummary)(() => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(0deg)",
    transition: "transform 0.3s ease",
  },
  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    display: "flex",
    alignItems: "center",
  },
}));

const FullWidthDivider = styled(Divider)(() => ({
  flexGrow: 1,
  marginLeft: "12px",
}));

export default function CustomAccordion({
  expanded,
  onChange,
  headerText,
  headerVariant = "subtitle1",
  children,
  id,
}: CustomAccordionProps) {
  return (
    <Accordion
      id={id}
      expanded={expanded}
      onChange={onChange}
      sx={{
        my: "0 !important", // something always adding margin to the accordion
        "&:before": {
          display: "none",
        },
      }}
    >
      <CustomAccordionSummary sx={{ px: 0 }} expandIcon={<ExpandMoreIcon />}>
        <Typography variant={headerVariant} sx={{ ml: "11px" }}>
          {headerText}
        </Typography>
        <FullWidthDivider orientation="horizontal" />
      </CustomAccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
